import { render, staticRenderFns } from "./photo-material-all.vue?vue&type=template&id=32d6903a&scoped=true&"
import script from "./photo-material-all.vue?vue&type=script&lang=js&"
export * from "./photo-material-all.vue?vue&type=script&lang=js&"
import style0 from "./photo-material-all.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./photo-material-all.vue?vue&type=style&index=1&id=32d6903a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d6903a",
  null
  
)

export default component.exports